export const PAGE_SIZES = [10, 20, 30, 50, 100, 200, 500];

export interface IPagination {
  pageSize: number;
  pageIndex: number;
  total?: number;
}
